// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0637d55a-168":"19e15cd6ca643fb0ea91","0637d55a-452":"559caa03d98a778651cd","0637d55a-379":"800a8eb818efcb5e9915","0637d55a-83":"494043b97d687df41e78"}[chunkId] + ".js";
};